import { RxReload } from 'react-icons/rx';
import { BsThreeDotsVertical } from 'react-icons/bs';

const UserRolesHeader = ({
  onReload,
  onNewPermission,
  onEditPermission,
  onAddUserRole,
  isLoading,
  searchTerm,
  onSearchChange,
}) => {
  return (
    <div className="flex justify-between items-center gap-2 p-3">
      <div className="flex items-center gap-3">
        <button
          onClick={onReload}
          className="p-2 hover:bg-gray-100 rounded cursor-pointer"
          title="Refresh"
          disabled={isLoading}
        >
          <RxReload size={20} className={isLoading ? 'animate-spin' : ''} />
        </button>
        <BsThreeDotsVertical size={20} />
      </div>

      <div className="search-bar flex-1 max-w-md mx-4">
        <input
          type="text"
          value={searchTerm}
          onChange={onSearchChange}
          placeholder="Search by role, division, description, or status..."
          className="search-input border-radius-10 w-full px-4 py-2 border border-gray-300 rounded-lg"
        />
      </div>

      <div className="flex items-center gap-5">
        <button
          onClick={onNewPermission}
          className="bg-secondary-50 text-secondary-800 rounded-full py-2 px-6 hover:bg-secondary-100"
        >
          New Permissions
        </button>
        <button
          onClick={onEditPermission}
          className="border border-secondary-700 text-secondary-700 bg-white py-2 px-5 rounded-full font-normal hover:bg-gray-50"
        >
          Edit Permissions
        </button>
        <button
          onClick={onAddUserRole}
          className="bg-secondary-700 text-white py-2 px-5 rounded-full font-normal hover:bg-secondary-800"
        >
          <span className="text-lg mr-3">+</span>
          Add User Role
        </button>
      </div>
    </div>
  );
};

export default UserRolesHeader;
